import { render, staticRenderFns } from "./AnalysisLabel.vue?vue&type=template&id=6ebc09e0&scoped=true"
import script from "./AnalysisLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalysisLabel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AnalysisLabel.vue?vue&type=style&index=0&id=6ebc09e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebc09e0",
  null
  
)

export default component.exports